import { useFlags } from "launchdarkly-react-client-sdk";
import { defaultFlags, type FeatureFlagValue } from "providers/LaunchDarkly/featureFlags";

// useFlags directly (not the LaunchDarkly wrapper) so this unit-tests without initializing the LD client.
export const useInterviewAvailabilityEnabled = (): boolean => {
  const flags = useFlags<FeatureFlagValue>();
  const jobsPhased = flags["jobs-phased"] ?? defaultFlags["jobs-phased"];
  return jobsPhased >= 3;
};
